import { render, staticRenderFns } from "./OffCanvasDetailsToimittaja.vue?vue&type=template&id=34922e59&scoped=true&"
import script from "./OffCanvasDetailsToimittaja.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsToimittaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34922e59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34922e59')) {
      api.createRecord('34922e59', component.options)
    } else {
      api.reload('34922e59', component.options)
    }
    module.hot.accept("./OffCanvasDetailsToimittaja.vue?vue&type=template&id=34922e59&scoped=true&", function () {
      api.rerender('34922e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsToimittaja.vue"
export default component.exports